import React from 'react';
import { motion } from 'framer-motion';
import { WifiIcon, ZapIcon, ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
export function Wireless5GPage({
  onNavigate
}: {
  onNavigate: (page: string) => void;
}) {
  return <div className="pt-20" data-id="element-2404">
      <section className="bg-slate-900 py-24 relative overflow-hidden" data-id="element-2405">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-2406"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2407">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="max-w-3xl" data-id="element-2408">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-2409">
              5G Wireless <span className="text-accent" data-id="element-2410">Business Internet</span>
            </h1>
            <p className="text-xl text-slate-300 mb-8" data-id="element-2411">
              High-speed, reliable wireless connectivity for businesses that
              need flexibility and rapid deployment.
            </p>
            <button onClick={() => onNavigate('contact')} className="bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center gap-2" data-id="element-2412">
              Check Coverage
              <ArrowRightIcon className="w-5 h-5" data-id="element-2413" />
            </button>
          </motion.div>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-2414">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2415">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-2416">
            {[{
            icon: ZapIcon,
            title: 'Rapid Deployment',
            desc: 'Get your business online in days, not weeks, with our plug-and-play 5G solutions.'
          }, {
            icon: WifiIcon,
            title: 'Ultra-Low Latency',
            desc: 'Experience fiber-like speeds and responsiveness over the air with next-gen 5G technology.'
          }, {
            icon: ShieldCheckIcon,
            title: 'Secure & Reliable',
            desc: 'Enterprise-grade security and automatic failover to ensure your business stays connected.'
          }].map((feature, i) => <div key={i} className="p-8 rounded-2xl bg-slate-50 border border-slate-100" data-id="element-2417">
                <div className="w-12 h-12 bg-accent/10 rounded-xl flex items-center justify-center mb-6" data-id="element-2418">
                  <feature.icon className="w-6 h-6 text-accent" data-id="element-2419" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2420">
                  {feature.title}
                </h3>
                <p className="text-slate-600" data-id="element-2421">{feature.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}